import { Reveal, SectionHead } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The Karigar Legacy",
    text: "Every Aradhana piece is hand-hammered and nakshi-carved by fourth-generation goldsmiths. Machines can polish metal — only hands can bless it.",
    img: "/assets/artisan-hands.png",
  },
  {
    n: "02",
    title: "Purity Without Compromise",
    text: "Computerised XRF purity testing, performed in front of you. Every ornament leaves with its BIS 916 hallmark and our name behind it.",
  },
  {
    n: "03",
    title: "Transparent Value",
    text: "Zero hidden wastage. Gold weight, stone value, making charges and GST — itemised line by line on every invoice, every single time.",
  },
  {
    n: "04",
    title: "Fair Exchange",
    text: "One hundred percent exchange value for your 916 hallmarked gold. No melting deductions, no fine print, no hesitation.",
  },
];

export const Manifesto = () => (
  <section id="heritage" data-testid="manifesto-section" className="relative border-y border-[#D4AF37]/10 bg-[#081022] py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <SectionHead
        eyebrow="The Aradhana Manifesto"
        title={<>Four chapters of <span className="gold-text italic">sworn craft.</span></>}
      />
      <div className="grid gap-16 lg:grid-cols-2 lg:gap-24">
        <Reveal>
          <div className="overflow-hidden rounded-t-[999px] border border-[#D4AF37]/25 p-3">
            <img
              src={CHAPTERS[0].img}
              alt="Aradhana goldsmith at the atelier"
              data-testid="manifesto-artisan-image"
              className="aspect-[3/4] w-full rounded-t-[999px] object-cover"
            />
          </div>
        </Reveal>
        <div className="flex flex-col justify-center">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div data-testid={`manifesto-chapter-${c.n}`} className="flex gap-8 border-t border-white/5 py-8 first:border-t-0">
                <span className="font-mono text-5xl font-light text-[#D4AF37]/25 sm:text-6xl">{c.n}</span>
                <div>
                  <h3 className="font-serif text-2xl text-white sm:text-3xl">{c.title}</h3>
                  <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-[#B5B0A8]">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
